import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-membership-icon',
  templateUrl: './membership-icon.component.html',
  styleUrls: ['./membership-icon.component.scss']
})
export class MembershipIconComponent implements OnInit, OnChanges {
  image = '0';
  text = '您还没有开通VIP';
  isVip = false;
  @Input()
  membership: string;
  @Input()
  noText = false;
  @Input()
  width;
  @Input()
  height;
  @Input() newIcon = false;
  @Input() canHover = false;
  @Input() textML = false;

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    switch (this.membership) {
      case 'cpvip': {
        this.image = '4';
        this.text = '情侣VIP';
        this.isVip = true;

        break;
      }
      case 'editor': {
        this.image = '4';
        this.text = '情侣VIP';
        this.isVip = true;
        break;
      }
      case 'etvip': {
        this.image = '4';
        this.text = '企业VIP';
        this.isVip = true;
        break;
      }
      case 'gvip': {
        this.image = '2';
        this.text = '黄金VIP';
        this.isVip = true;
        break;
      }
      case 'vip': {
        this.image = '0';
        this.text = '您还没有开通VIP';
        this.isVip = false;
        break;
      }
      case 'royalAdmin': {
        this.image = '4';
        this.text = '站长';
        this.isVip = true;
        break;
      }
      case 'royalVip': {
        this.image = '3';
        this.text = '至尊VIP';
        this.isVip = true;
        break;
      }
      case 'bigV': {
        this.text = '大V';
        this.isVip = true;
        break;
      }
      case 'speaker': {
        this.text = '官方运营';
        this.isVip = true;
        break;
      }
      default: {
        this.image = '0';
        this.text = '您还没有开通VIP';
        this.isVip = false;
        break;
      }
    }
  }
}
